module.exports = __webpack_public_path__ + "img/edge.b0349ccc.png";